import React from 'react';
import { connect } from 'react-redux';
import { Grid, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import LogoStockImagesCard from './LogoStockImagesCard';
import EmptyGalleryLabel from '../../../common/EmptyGalleryLabel';
import LogoStockImagesLoadMoreCard from './LogoStockImagesLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    imagesContentWrapper: {
        padding: `${theme.spacing(2)} 0`
    }
});

const galleryCardWidth = 146;
const galleryCardHeight = 146;

const LogoStockImagesContainer = (props) => {
    const { classes, logoStockImagesInitializing, logoStockImages, logoStockImagesAllCount } = props;

    return (
        <Grid className={classes.imagesContentWrapper}>
            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
            >
                {logoStockImagesInitializing ?
                    <Grid className={classes.galleryProgress}>
                        <CircularProgress />
                    </Grid>
                :
                    logoStockImages && logoStockImages.length
                    ?
                        <>
                            {logoStockImages.map((image, index) => 
                                <LogoStockImagesCard
                                    key={image.id}
                                    index={index}
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            )}

                            {logoStockImages.length < logoStockImagesAllCount && 
                                <LogoStockImagesLoadMoreCard 
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            }
                        </>
                    :
                    <EmptyGalleryLabel />      
                }
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const { 
        logoStockImagesInitializing,
        logoStockImages,
        logoStockImagesAllCount
    } = state.mediaPicker;

    return { 
        logoStockImagesInitializing,
        logoStockImages,
        logoStockImagesAllCount
    };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(LogoStockImagesContainer, styles));